assert = require 'app/scripts/lib/assert'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
t = require('app/scripts/views/internal/teacup-with-helpers')()
f = require 'effing'
trackEvent = require('@trello/analytics').track
locales = require('@trello/locale').supportedLocales
_ = require 'underscore'
bannerLocale = require('locale').banners
babble = require 'app/scripts/lib/babble'

track = f(trackEvent, 'Header', 'New Locale Banner')

module.exports = class NewLocaleBannerView extends WarningBannerView
  initialize: ({ @locale }) ->

  events:
    'click .js-switch-language': ->
      track("Set locale to #{@locale}")
      @setLocale()
    'click .js-dismiss': ->
      track("Dismiss #{@locale}")
      @dismiss(->)

  setLocale: ->
    @model.setPref 'locale', @locale, =>
      @dismiss =>
        document.location.reload()

  dismiss: (next) ->
    @model.dismissLanguageBannerFor @locale, =>
      @remove()
      next()

  render: ->
    # We have to translate the locale from a browser locale to a transifex
    # locale.
    translationsLocale = @locale.replace /-/, "_"
    data = bannerLocale[@locale] ? bannerLocale[translationsLocale] ? bannerLocale[translationsLocale.substr(0, translationsLocale.indexOf('_'))]
    assert data?, "Attempt to show a NewLocaleBanner with an unrecognized locale"
    language = _.find(locales, (locale) => locale.code == @locale)
    assert language?, "Attempt to show a NewLocaleBanner with an unrecognized language"

    @$el.html t.render ->
      t.text  data.mainText.replace "{language}", language.name
      t.text ' '
      t.a { href: '#', class: 'quiet primary js-switch-language' }, data.switchText
      t.text ' - '
      t.a { href: '#', class: 'quiet js-dismiss' }, data.dismissText
    @
